var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 0.1875L31 8.375C31.625 8.75 32 9.375 32 10.0625C32 11.125 31.125 12 30 12H16H1.9375C0.875 12 0 11.125 0 10.0625C0 9.375 0.375 8.75 0.9375 8.375L15.5 0.1875C15.8125 0 16.1875 0 16.4375 0.1875ZM19.125 10H29.8125L16 2.1875L2.125 10H12.8125C12.5625 9.5625 12.5 9.0625 12.5 8.5C12.5 6.625 14.0625 5 16 5C17.875 5 19.5 6.625 19.5 8.5C19.5 9.0625 19.375 9.5625 19.125 10ZM16 7C15.125 7 14.5 7.6875 14.5 8.5C14.5 9.375 15.125 10 16 10C16.8125 10 17.5 9.375 17.5 8.5C17.5 7.6875 16.8125 7 16 7ZM4 22V14H6V22H11V14H13V22H19V14H21V22H26V14H28V22C28.5 22 29 22.5 29 23C29 23.5625 28.5 24 28 24H4C3.4375 24 3 23.5625 3 23C3 22.5 3.4375 22 4 22ZM2.5 26H29.5C30 26 30.5 26.5 30.5 27C30.5 27.5625 30 28 29.5 28H2.5C1.9375 28 1.5 27.5625 1.5 27C1.5 26.5 1.9375 26 2.5 26ZM1 30H31C31.5 30 32 30.5 32 31C32 31.5625 31.5 32 31 32H1C0.4375 32 0 31.5625 0 31C0 30.5 0.4375 30 1 30Z",
    fill: "#2FB273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.595594fceb0ab1fcc50dba289b5ed2dd.svg";
export { ForwardRef as ReactComponent };